import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./search-actions.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./search-actions.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from "@angular/core";
import { SharedConstants } from "../../../constants/shared.constants";
import { ApplicationMapSearchService } from "../../../../tabs/applications/application-search/shared/application-map-search.service";
import { AlertType } from "../../../models/alert";
import { AppControllerService } from "../../../../app-controller.service";
import { MapService } from "../../../../map/shared/map.service";
import { AutoUnsub } from "../../../decorators/autounsub.decorator";
let SearchActionsComponent = class SearchActionsComponent {
    applicationMapSearchService;
    appControllerService;
    changeDetectorRef;
    mapService;
    advancedSearchLinkText = SharedConstants.ADVANCED_SEARCH_TEXT;
    mapLinkText = SharedConstants.MAP_TEXT;
    enlargeMapText = SharedConstants.ENLARGE_MAP_TEXT;
    shrinkMapText = SharedConstants.SHRINK_MAP_TEXT;
    isLargeMap;
    isMapVisible;
    showAdvancedButton = true;
    isMapVisibleSubscription;
    constructor(applicationMapSearchService, appControllerService, changeDetectorRef, mapService) {
        this.applicationMapSearchService = applicationMapSearchService;
        this.appControllerService = appControllerService;
        this.changeDetectorRef = changeDetectorRef;
        this.mapService = mapService;
    }
    ngOnInit() {
        this.applicationMapSearchService.setIsMapVisible(false);
        this.isMapVisibleSubscription = this.applicationMapSearchService.isMapVisibleAsObservable.subscribe((visible) => {
            this.isMapVisible = visible;
            this.mapLinkText = visible ? SharedConstants.HIDE_MAP_TEXT : SharedConstants.MAP_TEXT;
            this.changeDetectorRef.detectChanges();
        });
    }
    enlargeMap(enlarge) {
        this.applicationMapSearchService.setMapSizeLarge(enlarge);
        this.isLargeMap = enlarge;
        this.changeDetectorRef.detectChanges();
    }
    showMap() {
        if (this.applicationMapSearchService.hasApplicationLayer) {
            if (this.isMapVisible === true) {
                this.applicationMapSearchService.setIsMapVisible(false);
                this.isMapVisible = false;
            }
            else {
                this.applicationMapSearchService.setIsMapVisible(true);
                this.isMapVisible = true;
                this.mapService.setProceedMapLoading(true);
            }
            this.changeDetectorRef.detectChanges();
        }
        else {
            this.appControllerService.showMessage(SharedConstants.NO_APPLICATION_LAYER, AlertType.Warning);
        }
    }
    static ctorParameters = () => [
        { type: ApplicationMapSearchService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: MapService }
    ];
    static propDecorators = {
        showAdvancedButton: [{ type: Input }]
    };
};
SearchActionsComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-search-actions",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], SearchActionsComponent);
export { SearchActionsComponent };
